module.exports = __webpack_public_path__ + "static/media/step4_m.1df05459.png";